/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

const moduleName = 'security';
const componentName = 'geo-db-list-page';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleFiles = `${prefix}.columnTitleFiles`;
export const columnTitleMappings = `${prefix}.columnTitleMappings`;

export const ENGLISH = {
    [columnTitleFiles]: 'GeoDB Files',
    [columnTitleMappings]: 'GeoDB Mapping',
};
